import { api } from "@api/api";
import { BookActivity } from "@modules/bookActivities/types";
import { BookActivityFormValues } from "@modules/bookActivities/validations";

export async function createBookActivityService(
  data: BookActivityFormValues
): Promise<BookActivity> {

  const { data: bookActivity } = await api.post<BookActivity>(
    "v1/book_activity_admin/",
    {
      ...data,
      image: undefined,
    }
  );

  if(data.image) {
    const imageFormData = new FormData();
    imageFormData.append("image", data.image);

    await api.patch<BookActivity>(
      `v1/book_activity_admin/${bookActivity.id}/`,
      imageFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      }
    );
  }

  return bookActivity;
}
